import React, { InputHTMLAttributes, useEffect, useRef } from 'react';

import { useField } from '@unform/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  input: {},
}));

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  type?: string;
  isMultiline?: boolean;
  rows?: number;
  manualError?: string;
}

const Input: React.FC<InputProps> = ({
  name,
  label,
  type = 'text',
  isMultiline = false,
  rows = 1,
  manualError,
  ...rest
}) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <div>
      <TextField
        multiline={isMultiline}
        rows={rows}
        error={manualError ? !!manualError : !!error}
        helperText={manualError || error}
        inputProps={{ defaultValue, ref: inputRef, ...rest }}
        label={label}
        type={type}
        className={classes.input}
        variant="outlined"
        margin="dense"
        fullWidth
      />
    </div>
  );
};

export default Input;
